import React from 'react'

export const TeachingApproach = [
  {
    name: 'list',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/teachingApproach/TeachingApproachList'),
    ),
    path: '/admin/pedagogical-parameters/teaching-Approach',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'create',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/teachingApproach/TeachingApproachCreate'),
    ),
    path: '/admin/pedagogical-parameters/teaching-Approach/create',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
  {
    name: 'edit',
    component: React.lazy(() =>
      import('../../../modules/admin/pedagogical-parameters/teachingApproach/TeachingApproachEdit'),
    ),
    path: '/admin/pedagogical-parameters/teaching-Approach/edit/:teachingApproachId',
    guards: ['allowOnlyAdmin', 'allowOnlyLogged'],
  },
]
